// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 360px){h3[data-v-387a5f55]{font-size:1.4rem}}\n", ""]);
// Exports
module.exports = exports;
